import { render, staticRenderFns } from "./StatusPedidoManutencao.vue?vue&type=template&id=55a9e12e&scoped=true&"
import script from "./StatusPedidoManutencao.vue?vue&type=script&lang=js&"
export * from "./StatusPedidoManutencao.vue?vue&type=script&lang=js&"
import style0 from "./StatusPedidoManutencao.vue?vue&type=style&index=0&id=55a9e12e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a9e12e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
